class FoodItem {
    constructor(day, type, cont) {
        this.day = { 0: "Friday", 1: "Saturday", 2: "Sunday" }[day];
        this.type = type.split(" ").map(t => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase()).join(" ");
        this.cont = cont;
        this.key = ((length) => {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        })(5);
    }
}
export { FoodItem };